import * as React from "react";
import { Link } from "../../atoms/Link";
import logo from "../../../images/logo.svg";
import { EmailIcon, LinkedInIcon } from "../icons";
import { LANG_DE_DE, requestADemoPath } from "../../../constants";

const social = [
  {
    name: "Linkedin",
    href: "https://www.linkedin.com/company/omnidocapp",
    icon: LinkedInIcon,
  },
  {
    name: "Email",
    href: "mailto:kontakt@omnidoc.de",
    icon: EmailIcon,
  },
];

const navigation = [
  {
    name: "Datenschutz",
    items: [
      {
        name: "Allgemeinen Nutzungsbedingungen",
        href: "/de/nutzungsbedingungen",
      },
      { name: "Datenschutzerklärung", href: "/de/datenschutz" },
    ],
  },
  {
    name: "Kontaktieren Sie uns",
    items: [
      { name: "Demo buchen", href: requestADemoPath(LANG_DE_DE) },
      { name: "kontakt@omnidoc.de", href: "mailto:kontakt@omnidoc.de" },
    ],
  },
];

export const Footer = (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="xl:grid xl:grid-cols-3 xl:gap-8">
      <div className="space-y-8 xl:col-span-1">
        <img className="h-4 w-auto sm:h-4 mb-0" src={logo} alt="" />
        <p className="text-gray-500 text-base max-w-prose">
          Omnidoc ist ein unabhängiges Unternehmen, das 2019 gegründet wurde und
          sich ausschließlich der Entwicklung seiner Plattform für den Austausch
          zwischen Gesundheitsfachkräften widmet.
        </p>
        <div className="flex space-x-6">
          {social.map(item => (
            <Link
              key={item.name}
              to={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-5 w-5" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </div>
      <div
        className={`mt-12 grid grid-cols-2 md:grid-cols-${Math.min(navigation.length, 4)} gap-8 xl:mt-0 xl:col-span-2`}
      >
        {navigation.map(({ name, items }) => (
          <div key={name}>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              {name}
            </h3>
            <ul className="mt-4 space-y-4">
              {items.map(item => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-base text-gray-500 hover:text-gray-900"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
);
